import { api } from "@/api"
import { computed, ref } from "vue"
import { defineStore } from "pinia"

export const useGradeConversionStore = defineStore("gradeConversion", () => {
  const loading = ref(false)
  const baseYears = ref([])
  const selectedBaseYear = ref("")
  const rules = ref([])
  const result = ref(null)
  const errorMessage = ref("")

  const hasRules = computed(() => rules.value.length > 0)

  function setError(error) {
    errorMessage.value =
      error?.response?.data?.message ||
      error?.message ||
      "내신 변환 정보를 조회하지 못했습니다."
  }

  async function fetchBaseYears() {
    loading.value = true
    errorMessage.value = ""

    try {
      const { data } = await api.gradeConversion.baseYears()
      baseYears.value = data?.baseYears?.length ? data.baseYears : ["2026"]
      selectedBaseYear.value = selectedBaseYear.value || baseYears.value[0]

      return baseYears.value
    } catch (error) {
      setError(error)
      baseYears.value = ["2026"]
      selectedBaseYear.value = selectedBaseYear.value || "2026"

      return baseYears.value
    } finally {
      loading.value = false
    }
  }

  async function fetchRules(baseYear = selectedBaseYear.value) {
    loading.value = true
    errorMessage.value = ""

    try {
      const { data } = await api.gradeConversion.rules({ baseYear })
      rules.value = data?.rules || []
      selectedBaseYear.value = data?.baseYear || baseYear

      return rules.value
    } catch (error) {
      setError(error)
      rules.value = []

      return rules.value
    } finally {
      loading.value = false
    }
  }

  async function convert(sourceGrade) {
    loading.value = true
    errorMessage.value = ""
    result.value = null

    try {
      const { data } = await api.gradeConversion.convert({
        baseYear: selectedBaseYear.value || "2026",
        sourceGrade,
      })

      result.value = data

      return data
    } catch (error) {
      setError(error)
      throw error
    } finally {
      loading.value = false
    }
  }

  return {
    baseYears,
    selectedBaseYear,
    rules,
    result,
    loading,
    errorMessage,
    hasRules,
    fetchBaseYears,
    fetchRules,
    convert,
  }
})
